var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"application_page"},[_c('new-header',{attrs:{"config":_vm.headerConfig}}),_c('van-empty',{attrs:{"description":"当前无注册渠道"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }